import { TFunction } from "i18next";
import moment from "moment";
import { v4 } from "uuid";
import { DATE_TIME_FORMAT_TYPES } from "../configs/constants/DateTimeFormatTypes";
import { RecruitmentHistoryType } from "../configs/constants/RecruitmentHistoryType";
import { History } from "../models/RecruitmentHistory";

export const historyGrouping = (history: History[]) => {
	let level1: History[] = [];
	let level2: History[] = [];
	let level3: History[] = [];
	let statusItemIds: string[] = [];

	history.forEach((historyItem) => {
		switch (historyItem.type) {
			case RecruitmentHistoryType.STATUS_CHANGED:
				if (historyItem.data?.currentAction) {
					level2.push({
						...historyItem,
						id: v4(),
						type: RecruitmentHistoryType.CURRENT_ACTION_CHANGED,
						data: { currentAction: historyItem.data.currentAction },
						items: level3,
					});

					level3 = [];
				}

				historyItem.items = level2;
				level1.push(historyItem);

				level2 = [];

				statusItemIds.push(historyItem.id);

				break;

			case RecruitmentHistoryType.CURRENT_ACTION_CHANGED:
				historyItem.items = level3;
				level2.push(historyItem);

				level3 = [];

				break;

			case RecruitmentHistoryType.NEXT_ACTION_CHANGED:
			case RecruitmentHistoryType.NEXT_ACTION_DATE_CHANGED:
				break;

			default:
				level3.push(historyItem);
				break;
		}
	});

	return { groupedHistory: level1, statusItemIds };
};

export const getHistoryMetadataString = (date: Date, firstName?: string, lastName?: string) => {
	let name = "";

	if (firstName) name += firstName;
	if (lastName) name += " " + lastName.charAt(0);

	const dateStr = moment(date).format("YYYY-MM-DD, HH:mm");

	if (name) return `${dateStr} by ${name}`;

	return dateStr;
};

export function getSignedContractStatus(
	employmentContract: undefined | { dateSigned?: string | Date; dateSent: string | Date }[],
	t: TFunction
) {
	if (!employmentContract) {
		return "";
	}

	if (employmentContract) {
		const signedContract = employmentContract.find((ec: any) => ec.dateSigned);
		const sentContract = employmentContract.find((ec) => ec.dateSent);

		if (signedContract) {
			return (
				t("AGREEMENT_SIGNED") +
				" " +
				moment(signedContract.dateSigned).format(DATE_TIME_FORMAT_TYPES.DATE)
			);
		} else if (sentContract) {
			return (
				t("AGREEMENT_SENT") +
				" " +
				moment(sentContract.dateSigned).format(DATE_TIME_FORMAT_TYPES.DATE)
			);
		}
	}
	return "-";
}
